import React, { Component }  from 'react';
import SashiDoLogo from 'components/SashiDoLogo/SashiDoLogo.react';
import Icon from 'components/Icon/Icon.react';
import styles from './LoadingParticles.scss';

export default class LoadingParticles extends Component {
  constructor() {
    super();
  }

  render() {
    let particles = [];
    for (let i = 1; i < 40; i++) {
      particles.push(
        <span className={[styles.particle, styles['particle' + i]].join(' ')} key={i}>{i % 2 ? '0' : '1'}</span>
      );
    }

    return (
      <div className={[styles.appLoading, this.props.customClass ? styles[this.props.customClass] : null].join(' ')}>
        <div className={styles.bytes}>{this.props.particles != false && particles}</div>
        {
          this.props.logo != false &&
          <div className={styles.logo}>
            <div>
              <SashiDoLogo fade={true} relative={true} size={240} />
              <p>Made by developers for developers.</p>
              <Icon name='icon-heart' width={16} height={16} colored={true} />
            </div>
          </div>
        }
        {
          this.props.status &&
            <div className={styles.message}>{this.props.status}</div>
        }
      </div>
    );
  }
}
